import styled from 'styled-components'
import { BREAKPOINTS } from '../../constants/breakpoints'

export const OwnerContainer = styled.div`
  .button-create {
    > div {
      margin-left: auto;
    }
  }
`

export const DataContainer = styled.div`
  padding-bottom: 40px;

  .button-create {
    > div {
      margin-left: auto;
    }
  }

  .button-right {
    width: 100%;
    margin: auto;

    > button {
      margin-right: 0;
      margin-left: auto;
    }
  }

  .container {
    width: 100%;

    .row {
      width: 50%;
    }
  }

  .DFGreyBox {
    margin: 0;

    @media ${BREAKPOINTS.md} {
      margin: 0 50px;
    }
  }
`
